import { connect } from "react-redux";

import GlobalChangeOverTimeTable from "../../components/visualizations/global_change_over_time_table";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainTableData)) { return {}; }

  const data = ld.mainTableData;

  return { data };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalChangeOverTimeTable);
